import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /**
   * Handles cart update events and announces the new count to screen readers.
   * @param {CustomEvent<{ resource?: { item_count?: number } }>} event
   */
  #onCartUpdate = (event) => {
    const cartCount = event.detail.resource?.item_count;
    if (cartCount === undefined) return;

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}

/* WOCHITV_REMOVE_FEATURED_CARD_RUNTIME_20260704: hide flawed homepage featured-system card on cached storefront HTML. */
(function(){
  var css = '.whl__hero-card{display:none!important;visibility:hidden!important;pointer-events:none!important}' +
            '.whl__hero-inner{grid-template-columns:minmax(0,1fr)!important}' +
            '.whl__hero-copy{max-width:820px!important}' +
            '@media(max-width:760px){.whl__wa-float{display:none!important;visibility:hidden!important;pointer-events:none!important}.whl__hero-inner{padding-bottom:72px!important}.whl__metrics{margin-top:18px!important}}';
  var id = 'wochitv-remove-featured-card-runtime';
  function addStyle(){
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(s);
  }
  addStyle();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addStyle, { once: true });
})();

